import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import FilterComponent from "../Common/FilterComponent";
import DataTable from "react-data-table-component";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

//DataTable
import { StructureTableColumn } from "../../../Data/DataTables/OpsStructure";
import { ViewCompanyProfile } from "../../../Types/CompanyProfile/CompanyProfile";
import { ViewDeploymentSite } from "../../../Types/CompanyProfile/DeploymentSite";

//Services
import {
  VIEW_DEPSITE_QUERY_KEY,
  deploymentsiteService,
} from "../../../Services/deploymentsiteService";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
};

const DeploymentSiteTable = ({ companyInfo }: CompanyDataProps) => {
  const company_code = companyInfo?.code || "";
  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  const [filterText, setFilterText] = useState("");

  const deploymentSiteQueryKey = [...VIEW_DEPSITE_QUERY_KEY, company_code];

  const { data: DeploymentSiteData = [], isLoading: isDeploymentSiteLoading } =
    useQuery<ViewDeploymentSite[]>({
      queryKey: deploymentSiteQueryKey,
      queryFn: () =>
        deploymentsiteService.getAllViewDeploymentSiteByCompany(
          company_code as string,
        ),
    });

  const filteredItems: ViewDeploymentSite[] = DeploymentSiteData.filter(
    (item) =>
      item.status === 1 &&
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
  );

  return (
    <>
      <br />
      <H5 className="mb-1">Structure Overview</H5>
      <P className="mb-3 f-light f-w-200 f-12">
        Displays all <b>active</b> cluster and their corresponding deployment
        site currently set up in the system.
      </P>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive theme-scrollbar">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={StructureTableColumn}
          striped={true}
          pagination
          progressPending={isDeploymentSiteLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default DeploymentSiteTable;
